import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthorizationViewModel } from '@viewModels/AuthorizationViewModel/AuthorizationViewModel';
import { ROUTES } from '@configs/AppRoutes';

export const useRestoreLastRoute = () => {
    const {
        isAuthorizationLoading,
        bearerToken,
        lastAuthorizedPath,
        setLastAuthorizedPath,
    } = useAuthorizationViewModel();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (isAuthorizationLoading || (bearerToken && bearerToken !== ''))
            return;

        if (
            !lastAuthorizedPath ||
            lastAuthorizedPath === '' ||
            lastAuthorizedPath === null
        )
            return;
        setLastAuthorizedPath(null);

        const target = lastAuthorizedPath.startsWith('#')
            ? lastAuthorizedPath.slice(1)
            : lastAuthorizedPath;
        const current = location.pathname + location.search + location.hash;
        if (target === current) return;

        const isProtected = /^\/home\/(?!$)/.test(target);
        navigate(isProtected ? ROUTES.BOM : target, { replace: true });
    }, [bearerToken, isAuthorizationLoading, navigate, location]);
};
